/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";
import { withRouter } from 'react-router-dom'
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Typography,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Button,
  Slide,
  IconButton,
  TextField,
  CircularProgress,
  Snackbar,
  ListSubheader,
  Dialog,
  Tabs,
  Tab,
} from "@material-ui/core";
import Actions from "../../fluid/Actions/ActionFactory";
import TicketCard from "./components/TicketCard";

import { ArrowBack, Clear } from '@material-ui/icons'
import { Autocomplete, Pagination } from '@material-ui/lab'

import Result from "../Results/Result";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../tableIcons";

import Ticket from './components/Ticket'
import AttachmentContainer from "./components/AttachmentContainer";
import valueType from "../FlexForm/config/valueType"
import Action from "../../fluid/Actions/ActionFactory";

import LinkedScreen from "../LinkedScreens/LinkedScreen";

const clone = require('safe-clone-deep');
let equal = require('deep-equal')

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const styles = (theme) => ({
  select_ic: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  queue: {
    display: "flex",
    flexDirection: "column",
  },
  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
  in_progress: {
    animation: "$spin 1s infinite linear",
  },
  half_width: {
    width: "48%",
    margin: "1%",
    border: "1px solid rgba(0,0,0,0.12)",
    borderRadius: "3px",
    padding: "5px",
  },
  full_width: {
    width: "98%",
    margin: "1%",
    borderBottom: "1px solid rgba(0,0,0,0.12)",
    borderRadius: "3px",
    padding: "5px",
  },
});

class Queue extends Component {
  state = {
    init_error : false,
    drl_url: null,
    ic_selectable : true,
    ic_loading : false, 
    ic_list: [],
    iu_selectable : true,
    iu_loading : false,
    iu_list: [],
    ic_list_error: false,
    iu_list_error: false,
    ic_name: null,
    iu_name: null,
    tickets: null,
    raw_data : null,
    pages : null,
    cur_page : 1,
    getting_tickets: false,
    list_open: true,
    selected_ticket: null,
    selected_rowData: null,
    selected_ticket_error : null,
    getting_selected_ticket : false,
    selected_ticket_object : null,
    selected_ticket_display_config : null,
    selected_ticket_state: null,
    selected_ticket_resolution: null,
    wv_error: false,
    iu_wv_fields_error: false,
    query_object: null,
    class_query_object : null,
    result_received : false,
    class_result_received : false,
    query_result: null,
    class_result : [],
    query_error : false,
    searching: false,
    snackbar_open: false,
    submitting: false,
    submit_error: false,
    escalating: false,
    escalate_error: false,
    error: false,
    error_message: null,
    columns : null,
    show_recommendation_from_default_ic : true,
    show_ticket : true,
    show_table : true,
    show_back : true,
    reference_field : null,
    copy_to_parent : false,
    average_record_size : null,
    max_batch_threshold : null,
    last_offset : 0,
    limit : null,
    filters : [],
    updating_record : false,
    update_record_error : false,
    window_width : null,
    window_height : null,
    additional_attachments : [],
    cta_config : [],
    external_sources : [],
    results_tab : 0,
    get_global_attachments : false
  };

  componentWillMount () {
    this.setParams()
    Actions("http_request", {
      url: "/sainapse/data_rendering_service",
      method: "get",
      data: {},
    }).then((res) => {
      console.log("DRL Result: ", res.data);
      this.setState({ ...this.state, drl_url: res.data.result[0].url }, () => this.resizeWindow());
    });
  }

  componentDidMount () {
    window.addEventListener('resize', this.resizeWindow)
  }

  componentDidUpdate (prevProps) {
    console.log("Prev Location : ", prevProps.location.pathname)
    console.log("Current Location : ", this.props.location.pathname)
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setParams()
    }
  }

  resizeWindow = () => {
    // console.log("Queue Window Resized")
    // var toPX = require("to-px");
    // let window_width = this.state.show_ticket ? toPX("65vw") : toPX("100vw")
    // let window_height = this.props.params.showAppbar === undefined ? toPX("100vh") - 60 : JSON.parse(this.props.params.showAppbar) ? toPX("100vh") - 60 : toPX("100vh")
    // this.setState({...this.state, window_height : window_height, window_width : window_width}, () => {
    //   console.log("Queue :: Reco Width : ", this.state.window_width)
    //   console.log("Queue :: Reco Height : ", this.state.window_height)
    // })
    console.log("Queue :: Window Resized")
    var toPX = require("to-px");
    let window_width = this.state.show_ticket ? toPX("65vw") : toPX("100vw")
    console.log("Queue :: Window Width : ", window_width)
    let window_height = this.props.params.showAppbar === undefined ? toPX("100vh") - 60 : JSON.parse(this.props.params.showAppbar) ? toPX("100vh") - 60 : toPX("100vh")
    
    this.setState({...this.state, window_width : window_width, window_height : window_height}, () => {
      console.log("Queue :: Reco Width : ", this.state.window_width)
      console.log("Queue :: Reco Height : ", this.state.window_height)
    })

  }

  setParams = () => {
    let params = {
      ic_name : null,
      iu_name : null,
      recordID : null,
      columns : null,
      reference_field : null,
      show_ticket : true,
      show_table : true,
      show_back : true,
      copy_to_parent : false,
      cta_config : [],
      external_sources : [],
      get_global_attachments : false
    }

    let query_params = this.loadQueryParams()
    console.log("Query Params : ", query_params)
    let default_params = this.loadDefaultParams()
    console.log("Default Params : ", default_params)

    params.ic_name = query_params.icName !== null && query_params.icName !== undefined && query_params.icName !== "" ? query_params.icName : null
    params.iu_name = query_params.iuName !== null && query_params.iuName !== undefined && query_params.iuName !== "" ? query_params.iuName : null
    params.recordID = query_params.recordID !== null && query_params.recordID !== undefined && query_params.recordID !== ""  ? query_params.recordID : null

    params.ic_name = default_params.icName !== null && default_params.icName !== undefined && default_params.icName !== "" ? default_params.icName : params.ic_name
    params.iu_name = default_params.iuName !== null && default_params.iuName !== undefined && default_params.iuName !== "" ? default_params.iuName : params.iu_name
    //params.recordID = default_params.ticketID !== null && default_params.ticketID !== undefined && default_params.ticketID !== "" ? default_params.ticketID : params.recordID

    params.show_ticket = default_params.show_ticket !== null && default_params.show_ticket !== undefined && default_params.show_ticket !== "" ? default_params.show_ticket : true
    params.show_table = default_params.show_table !== null && default_params.show_table !== undefined && default_params.show_table !== "" ? default_params.show_table : true
    params.show_back = default_params.show_back !== null && default_params.show_back !== undefined && default_params.show_back !== "" ? default_params.show_back : true
    params.average_record_size = default_params.average_record_size !== null && default_params.average_record_size !== undefined && default_params.average_record_size !== "" ? default_params.average_record_size : null
    params.max_batch_threshold = default_params.max_batch_threshold !== null && default_params.max_batch_threshold !== undefined && default_params.max_batch_threshold !== "" ? default_params.max_batch_threshold : null
    params.filters = default_params.filters !== null && default_params.filters !== undefined ? default_params.filters : []
    params.external_sources = default_params.external_sources ? default_params.external_sources !== null ? default_params.external_sources : [] : []
    params.cta_config = default_params.cta_config ? default_params.cta_config !== null ? default_params.cta_config : [] : []
    params.get_global_attachments = default_params.get_global_attachments ? default_params.get_global_attachments !== null ? default_params.get_global_attachments : false : false
    let limit
    if (params.max_batch_threshold !== null &&  params.average_record_size !== null) {
      limit = Math.round(Number(params.max_batch_threshold) / Number(params.average_record_size))
    } else {
      limit = 20
    }
  
    if (default_params.icName !== null && default_params.iuName !== null) {
      params.columns = default_params.columns !== null && default_params.columns !== undefined ? default_params.columns : []
    }

    if (query_params.embed !== undefined) {
      if (JSON.parse(query_params.embed) === true) {
        params.copy_to_parent = default_params.copy_to_parent !== null && default_params.copy_to_parent !== undefined && default_params.copy_to_parent !== "" ? default_params.copy_to_parent : false
        if (default_params.reference_field !== null && default_params.reference_field !== undefined) {
          params.reference_field = default_params.reference_field
          params.recordID = query_params.referenceID !== null && query_params.referenceID !== undefined && query_params.referenceID !== ""  ? query_params.referenceID : null
        }
      }
    }

    console.log("Final Params : ", params)
    if (params.ic_name !== null && params.iu_name !== null) {
      this.setState({
        ...this.state,
        ic_selectable : false,
        ic_name : params.ic_name,
        iu_selectable : false,
        iu_name : params.iu_name,
        selected_ticket : params.recordID,
        columns : params.columns,
        reference_field : params.reference_field,
        show_table : params.show_table,
        show_ticket : params.show_ticket,
        show_back : params.show_back,
        copy_to_parent : params.copy_to_parent,
        average_record_size : params.average_record_size,
        max_batch_threshold : params.max_batch_threshold,
        filters : params.filters,
        limit : limit,
        cta_config : params.cta_config,
        external_sources : params.external_sources,
        get_global_attachments : params.get_global_attachments
      }, () => {
        console.log("On Load State : ", this.state)
        let sorted_column_index = this.state.columns.findIndex(column => column.sort !== null)
        let id_index = this.state.columns.findIndex(column => column.type === 'id')
        let date_index = this.state.columns.findIndex(column => column.type === 'date-time')
        if (sorted_column_index === -1 || id_index === -1 || date_index === -1) {
          this.setState({...this.state, init_error : true})
        } else {
          this.setState({...this.state, init_error : false}, () => this.getTickets(this.state.ic_name, this.state.iu_name, this.state.columns[sorted_column_index].name, this.state.columns[sorted_column_index].sort))
        }
      })
    }
  }

  loadQueryParams = () => {
    let params = this.props.params
    let params_with_values = Object.entries(params).filter(entry => entry[1] !== null)
    return Object.fromEntries(params_with_values) 
  }

  loadDefaultParams = () => {
    let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
    let screens = routes.find(section => section.id === 'cases')
    let screen = screens.screens.find(route => route.route === this.props.location.pathname)
    let params = screen.default_params
    let params_with_values = Object.entries(params).filter(entry => entry[1] !== null)
    return Object.fromEntries(params_with_values) 
  }

  getICList = () => {
    this.setState({...this.state, ic_list : [], ic_loading : true, ic_list_error : false}, () => {
      Actions("http_request", {
        url: "/sainapse/information_channel",
        method: "get",
        data: {},
      })
        .then((res) => {
          let ic_list = res.data.result.filter(
            (ic) =>
              ic.operations.includes("Recommend") &&
              ic.information_units.length > 0 &&
              ic.information_units.find((iu) => iu.type === "SM")
          );
          let recommend_ic_list = [];
          for (let i = 0; i < ic_list.length; i++) {
            if (ic_list[i].operations.includes("Recommend")) {
              let ic = {
                name: ic_list[i].name,
                trained: false,
              };
              if (
                ic_list[i].training_status_object.findIndex(
                  (el) =>
                    (el.operation === "Recommend" ||
                      el.operation === "Classify") &&
                    el.status === "Completed"
                ) !== -1
              ) {
                ic.trained = true;
              }
  
              recommend_ic_list.push(ic);
            }
          }
  
          this.setState({
            ...this.state,
            ic_list: recommend_ic_list,
            ic_list_error: false,
            ic_loading : false
          }, () => console.log("Queue State : ", this.state));
        })
        .catch((err) => {
          this.setState({
            ...this.state,
            ic_list: [],
            ic_list_error: true,
            ic_loading : false
          });
        });
    })
  };

  getIUList = (ic_name) => {
    this.setState({...this.state, iu_list : [], iu_loading : true, iu_list_error : false}, () => {
      Actions("http_request", {
        url: "/sainapse/information_channel/" + ic_name.name + "/information_unit/",
        method: "get",
        data: {},
      })
        .then((res) => {
          console.log("IU List :", res.data.result);
          let iu_list = res.data.result.filter((iu) => iu.type === "SM");
          this.setState({
            ...this.state,
            iu_list: iu_list,
            iu_list_error: false,
          }, () => console.log("Queue State : ", this.state));
        })
        .catch((err) => {
          this.setState({
            ...this.state,
            iu_list: [],
            iu_list_error: true,
          });
        });
    })
  };

  renderScreenName = () => {
    let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer

    let screens = routes.find(section => section.id === 'cases')
    console.log("Screens : ", screens)
    console.log("Path: ", this.props.location.pathname)
    let screen = screens.screens.find(route => route.route === this.props.location.pathname)
    let screen_name = screen.name
    console.log("Screen Name :", screen_name)

    return (
      <Typography variant = 'h6'>{screen_name}</Typography>
    )
  }

  handleChange = (state_key, value) => {
    this.setState({
      ...this.state,
      [state_key]: value,
    });
  };

  renderICSelect = () => {
    if (this.state.ic_selectable) {
      return (
        <Autocomplete
          id="tags-standard"
          options={this.state.ic_list}
          getOptionLabel = {(option) => option.name}
          getOptionDisabled = {(option) => option.trained === false}
          value = {this.state.ic_name}
          onOpen = {() => this.getICList()}
          onChange = {(event, newValue) => this.handleChange("ic_name", newValue)}
          loading = {this.state.ic_loading}
          defaultValue = {this.state.ic_name}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Information Channel"
              variant = 'filled'
              size = 'small'
            />
          )}
        />
      );
    } else {
      return (
        <div style = {{width : '100%', height : '50px', padding : '5px', marginRight : '5px'}}>
          <Typography style = {{display : 'block'}} variant = 'caption' color = 'textSecondary'>Information Channel</Typography>
          <Typography variant = 'body1'>{this.state.ic_name}</Typography>
        </div>
      );
    }
  };

  renderIUSelect = () => {
    if (this.state.iu_selectable) {
      return (
        <Autocomplete
          id="tags-standard"
          options={this.state.iu_list}
          getOptionLabel = {(option) => option.name}
          value = {this.state.iu_name}
          onOpen = {() => this.getIUList(this.state.ic_name)}
          onChange = {(event, newValue) => this.handleChange("iu_name", newValue)}
          loading = {this.state.iu_loading}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Information Unit"
              variant = 'filled'
              size = 'small'
            />
          )}
        />
      );
    } else {
      return (
        <div style = {{width : '100%', height : '50px', padding : '5px', marginRight : '5px'}}>
          <Typography style = {{display : 'block'}} variant = 'caption' color = 'textSecondary'>Information Unit</Typography>
          <Typography variant = 'body1'>{this.state.iu_name}</Typography>
        </div>
      );
    }
  };

  renderICs = () => {
    let ic_list = this.state.ic_list.map((ic) => {
      return ic.trained ? (
        <MenuItem value={ic.name}>{ic.name}</MenuItem>
      ) : (
        <MenuItem
          disabled={true}
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            borderBottom: "1px solif rgba(0,0,0,0.12)",
          }}
        >
          <Typography style={{ flexGrow: 1 }}>{ic.name}</Typography>
          {ic.trained === false ? (
            <Typography variant="caption">Not Trained</Typography>
          ) : null}
        </MenuItem>
      );
    });

    return ic_list;
  };

  renderIUs = () => {
    let ic_list = this.state.iu_list.map((iu) => {
      return <MenuItem value={iu.name}>{iu.name}</MenuItem>;
    });

    return ic_list;
  };

  renderGetTickets = () => {
    if (this.state.ic_selectable && this.state.iu_selectable) {
      return (
        <Button
          style={{
            marginTop: "10px",
          }}
          variant="contained"
          size="small"
          color="primary"
          fullWidth
          disabled = {this.state.ic_name !== null && this.state.iu_name !== null ? false : true}
          startIcon={
            this.state.getting_tickets ? (
              <CircularProgress style={{ color: "#FFFFFF" }} size={20} />
            ) : null
          }
          onClick={() => {
            let sorted_column_index = this.state.columns.findIndex(column => column.sort !== null)
            this.getTickets(this.state.ic_name.name, this.state.iu_name.name, this.state.columns[sorted_column_index].name, this.state.columns[sorted_column_index].sort)
          }}
        >
          Retrieve Open Incidents
        </Button>
      );
    }
  };

  getTickets = (ic_name = this.state.ic_name, iu_name = this.state.iu_name, column_name = null, order = 'asc') => {
    console.log("Column Name : ", column_name)
    let data = this.generateAPIData(ic_name, iu_name, column_name, order)

    this.setState({ ...this.state, getting_tickets: true, tickets : null }, () => {
      let size_data = this.generateAPIData(ic_name, iu_name, column_name, order)
      delete size_data.limit
      delete size_data.offset
      Actions("http_request", {
        url: "/sainapse/information_channel/" + ic_name + "/information_unit/" + iu_name + "/data_size",
        method: "post",
        data: size_data,
      }).then(res => {
        let num_pages = Math.ceil(res.data.result.total_records / this.state.limit)
        Actions("http_request", {
          url:
            "/sainapse/information_channel/" +
            ic_name +
            "/information_unit/" +
            iu_name +
            "/raw_data",
          method: "post",
          data: data,
        }).then((res) => {
          if (this.state.selected_ticket !== null) {
            let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
            let screens = routes.find(section => section.id === 'cases')
            let screen = screens.screens.find(route => route.route === this.props.location.pathname)
            let params = screen.default_params
            let columns = params.columns
            let id_field
            if (this.state.reference_field !== null) {
              id_field = this.state.reference_field
            } else {
              id_field = columns.find(column => column.type === 'id').name
            }
            console.log("Selected ID Field : ", id_field)
            let tickets = res.data.result.map(record => {
              let ticket = {}
              record.fields.map(field => {
                ticket[field.name] = field.value
              })
              return ticket
            })
            let record = tickets.find(item => item[id_field] === this.state.selected_ticket)
            this.setState({
              ...this.state,
              selected_ticket : null,
              getting_tickets: false,
              tickets: tickets,
              raw_data : res.data.result
            }, () => this.selectTicket(record));
          } else {
            let tickets = res.data.result.map(record => {
              let ticket = {}
              record.fields.map(field => {
                ticket[field.name] = field.value
              })
              return ticket
            })
            this.setState({
              ...this.state,
              selected_ticket : null,
              getting_tickets: false,
              tickets: tickets,
              pages : num_pages,
              raw_data : res.data.result
            })
          }
          console.log("Open Tickets: ", res.data.result);
        }).catch((err) => {
          this.setState({
            ...this.state,
            error: true,
            error_message: err,
            tickets : null,
            getting_tickets: false,
            selected_ticket: null,
            raw_data : null
          });
        });
      }).catch(err => {
        this.setState({
          ...this.state,
          error: true,
          error_message: err,
          tickets : null,
          getting_tickets: false,
          selected_ticket: null,
          raw_data : null
        });
      })
    });
  };

  generateAPIData = (ic_name = this.state.ic_name, iu_name = this.state.iu_name, column_name, order) => {
    let data = {}
    let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
    let screens = routes.find(section => section.id === 'cases')
    let screen = screens.screens.find(route => route.route === this.props.location.pathname)
    let params = screen.default_params
    let columns = params.columns
    let id_field = columns.find(column => column.type === 'id').name
    console.log("Selected ID Field : ", id_field)


    if (this.state.selected_ticket !== null) {
      let data_markers = [
        {
          trigger: {
             condition: {
                field : this.state.reference_field === null ? id_field : this.state.reference_field,
                operator: {
                   name : "equals",
                   params:[
                      {
                         name : "value",
                         value : {
                            number : null,
                            text : this.state.selected_ticket,
                            list : null,
                            boolean : null
                         },
                         elements : null,
                         component : "text",
                         component_params : null
                      }
                   ]
                }
             },
             boolop : "leaf"
          },
          actions : [
             {
                name : "include",
                params : []
             }
          ]
       }
      ]

      let fields_in_scope = columns.map(field => {
        return {
          fieldName : field.name,
          getAttachments : field.get_attachments,
          include_file_extensions : field.include_file_extensions,
          processAttachments : field.process_attachments
        }
      })

      let record_level_attachment_query = {
        fetchRecordLevelAttachments : params.get_global_attachments,
        include_file_extensions : params.global_attachment_file_types,
        processRecordLevelAttachments : params.process_global_attachments
      }

      data.data_markers = data_markers
      data.fields_in_scope = fields_in_scope
      data.limit = 1
      data.offset = 0
      data.record_level_attachment_query = record_level_attachment_query
    } else {
      data.data_markers = []

      let fields_in_scope = columns.map(field => {
        return {
          fieldName : field.name,
          getAttachments : false,
          include_file_extensions : [],
          processAttachments : false
        }
      })

      let record_level_attachment_query = {
        fetchRecordLevelAttachments : false,
        include_file_extensions : [],
        processRecordLevelAttachments : false
      }

      // let record_level_attachment_query = {
      //   fetchRecordLevelAttachments : params.get_global_attachments,
      //   include_file_extensions : params.global_attachment_file_types,
      //   processRecordLevelAttachments : params.process_global_attachments
      // }

      data.fields_in_scope = fields_in_scope
      let limit = this.state.limit
      data.limit = limit
      data.offset = this.state.last_offset
      data.record_level_attachment_query = record_level_attachment_query

      if (column_name !== null) {
        let order_by = []
        let field = {
          field : column_name,
          order : order
        }
        order_by.push(field)
        data.order_by = order_by
      }
    }

    return data
  }

  getNumberofPages = (num_of_tickets, limit) => {
    let num_pages = Math.ceil(num_of_tickets / limit)
    return num_pages
  }

  submitTicket = () => {
    let resolved_field = this.props.config.actions.find(
      (action) => action.name === "Resolve"
    );
    let state_field = this.props.config.fields.find(
      (field) => field.name === "State"
    );
    this.setState(
      {
        ...this.state,
        submitting: true,
      },
      () => {
        let ticket_index = this.state.tickets.findIndex(
          (ticket) =>
            ticket[
              this.props.config.fields.find((field) => field.type === "id")
                .raw_field_name
            ] === this.state.selected_ticket
        );
        let ticket = this.state.tickets[ticket_index];
        ticket[state_field.raw_field_name] = this.state.selected_ticket_state;
        ticket[
          resolved_field.key_to_update
        ] = this.state.selected_ticket_resolution;
        Actions("http_request", {
          url:
            "/sainapse/information_channel/" +
            this.state.ic_name +
            "/information_unit/" +
            this.state.iu_name +
            "/update_data",
          method: "post",
          data: {
            data: [ticket],
          },
        })
          .then((res) => {
            this.setState(
              {
                ...this.state,
                list_open: true,
                selected_ticket: null,
                selected_ticket_state: null,
                selected_ticket_resolution: null,
                wv_error: false,
                iu_wv_fields_error: false,
                query_object: null,
                query_result: null,
                searching: false,
                snackbar_open: false,
                submitting: false,
                submit_error: false,
              },
              () => {
                let sorted_column_index = this.state.columns.findIndex(column => column.sort !== null)
                this.getTickets(this.state.ic_name.name, this.state.iu_name.name, this.state.columns[sorted_column_index].name, this.state.columns[sorted_column_index].sort)
              }
            );
          })
          .catch((err) => {
            this.setState({
              ...this.state,
              submit_error: true,
              submitting: false,
            });
          });
      }
    );
  };

  escalateTicket = () => {
    let assignee_field = this.props.config.actions.find(
      (action) => action.name === "Escalate"
    );

    this.setState(
      {
        ...this.state,
        escalating: true,
      },
      () => {
        let ticket_index = this.state.tickets.findIndex(
          (ticket) =>
            ticket[
              this.props.config.fields.find((field) => field.type === "id")
                .raw_field_name
            ] === this.state.selected_ticket
        );
        let ticket = this.state.tickets[ticket_index];
        ticket[assignee_field.key_to_update] = assignee_field.preset_value;
        Actions("http_request", {
          url:
            "/sainapse/information_channel/" +
            this.state.ic_name +
            "/information_unit/" +
            this.state.iu_name +
            "/update_data",
          method: "post",
          data: {
            data: [ticket],
          },
        })
          .then((res) => {
            this.setState(
              {
                ...this.state,
                list_open: true,
                selected_ticket: null,
                selected_ticket_state: null,
                selected_ticket_resolution: null,
                wv_error: false,
                iu_wv_fields_error: false,
                query_object: null,
                query_result: null,
                searching: false,
                snackbar_open: false,
                submitting: false,
                submit_error: false,
                escalating: false,
                escalate_error: false,
              },
              () => {
                let sorted_column_index = this.state.columns.findIndex(column => column.sort !== null)
                this.getTickets(this.state.ic_name.name, this.state.iu_name.name, this.state.columns[sorted_column_index].name, this.state.columns[sorted_column_index].sort)
              }
            );
          })
          .catch((err) => {
            this.setState({
              ...this.state,
              escalate_error: true,
              escalating: false,
            });
          });
      }
    );
  };

  getTicketValue = (ticket_id, field) => {
    let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
    let screens = routes.find(section => section.id === 'cases')
    let screen = screens.screens.find(route => route.route === this.props.location.pathname)
    let params = screen.default_params
    let columns = params.columns
    let id_field = columns.find(column => column.type === 'id').name

    let ticket = this.state.tickets.find(ticket => ticket[id_field] === ticket_id)
    console.log("Ticket : ", ticket)
    let field_value = ticket[field]
    console.log("Field Value : ", field_value)

    return field_value
  }

  generateMultiFieldQueryObject = (params) => {
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" + this.state.ic_name + "/world_view",
      method: "get",
      data: {},
    })
      .then((res) => {
        console.log("WV Result :", res.data.result);
        let wv_config = res.data.result
        let wv_field_list = wv_config.configs.find(
          (config) => config.operation === "Recommend"
        );
        console.log("WV Field List :", wv_field_list);
        let wv_fields = wv_field_list.fields.filter(
          (field) => field.role === "Predictor"
        );
        console.log("World View :", wv_fields);
        Actions("http_request", {
          url:
            "/sainapse/information_channel/" +
            this.state.ic_name +
            "/information_unit/" +
            this.state.iu_name +
            "/world_view",
          method: "get",
          data: {},
        })
          .then((res) => {
            let iu_wv_fields = res.data.result.world_view_fields;
            console.log("IU WV Fields :", iu_wv_fields);
            let query_object = [];
            wv_fields.map((field) => {
              console.log("Field :", field);
              let field_object = {};
              field_object.field_name = field.name;
              field_object.search_query = [];
              let iu_field_base = iu_wv_fields.find(
                (iu_field) => iu_field.name === field.name
              ).base;
              console.log("Field Base:", iu_field_base);
              let field_value = iu_field_base.map((iu_field) => {
                console.log("IU Field : ", iu_field)
                let value = this.getTicketValue(this.state.selected_ticket, iu_field);
                console.log("Field Value : ", value)
                return value
              });
              console.log("Field Value:", field_value);
              field_object.search_query = field_value.join(" ");
              console.log("Search Query: ", field_object.search_query);
              query_object.push(field_object);
            });
            console.log("Query Object : ", query_object)

            let multi_field_query_object = []
            let default_ic = {
              ic_name : this.state.ic_name,
              search_options : query_object
            }
            if (this.state.show_recommendation_from_default_ic) {
              multi_field_query_object.push(default_ic)
            }

            let additional_ic_query_object = params.reco_sources !== null ? this.getAdditionalICQueryObject(params, "Recommend") : []
            multi_field_query_object = [...multi_field_query_object, ...additional_ic_query_object]
            console.log("Multi Field Query Object : ", multi_field_query_object)
            multi_field_query_object.forEach(query_ic => {
              let filter = this.state.filters.find(filter => filter.ic_name === query_ic.ic_name)
              if (filter !== undefined) {
                query_ic.filters = [filter]
              }
            })
            let class_query_object = this.generateClassificationQueryObject(params, wv_config, iu_wv_fields)
            console.log("Multi Field Class Query Object : ", class_query_object)

            this.setState(
              {
                ...this.state,
                wv_error: false,
                iu_wv_fields_error: false,
                query_object: multi_field_query_object,
                searching: true,
              },
              () => {
                Actions("http_request", {
                  url: "/sainapse/recommendation/multifield",
                  method: "post",
                  data: this.state.query_object,
                }).then((res) => {
                  this.setState(
                    {
                      ...this.state,
                      query_result: res.data.result,
                      searching: false,
                      result_received : true,
                      query_error : false,
                    },
                    () => console.log("Query Result :", res.data.result)
                  );
                }).catch(err => {
                  this.setState({
                    ...this.state, 
                    query_result : null, 
                    result_received : true,
                    searching : false, 
                    query_error : true
                  })
                })
                Actions("http_request", {
                  url : "/sainapse/classification/multifield",
                  method : "post",
                  data : class_query_object
                }).then(res => {
                  this.setState({...this.state, 
                    class_result : res.data.result,
                    class_result_received : true
                  })
                }).catch(err => {
                  this.setState({...this.state, class_result : [], class_result_received : true})
                })
              }
            );
          })
          .catch((err) => {
            this.setState({
              ...this.state,
              iu_wv_fields_error: true,
            });
          });
      })
      .catch((err) => {
        this.setState({
          ...this.state,
          wv_error: true,
        });
      });
  };

  getAdditionalICQueryObject = (params, operation) => {
    let additional_query = []
    params.reco_sources.map(source => {
      let query_object = {
        ic_name : source.ic_name,
        search_options : []
      }
      let search_options = source.search_options.find(option => option.operation === operation)
      if (search_options !== undefined) {
        query_object.search_options = search_options.search_options.map(field => {
          let field_object = {
            field_name : field.field_name,
            search_query : field.constructor.map(raw_field => this.getTicketValue(this.state.selected_ticket, raw_field)).join(' ')
          }
          return field_object
        })
        additional_query.push(query_object)
      }
    })

    return additional_query
  }

  generateClassificationQueryObject = (params, wv_config, iu_wv_fields) => {
    console.log("[Class] ", params)
    console.log("[Class] ", wv_config)
    console.log("[Class] ", iu_wv_fields)

    let class_query_object = []

    let default_query_object = {
      ic_name : this.state.ic_name,
      search_options : []
    }

    let class_config = wv_config.configs.find(config => config.operation === "Classify")
    if (class_config !== undefined) {
      let predictor_fields = class_config.fields.filter(field => field.role === "Predictor")
      default_query_object.search_options = predictor_fields.map(field => {
        let object = {
          field_name : field.name,
          search_query : iu_wv_fields.find(iu_field => iu_field.name === field.name).base.map(raw_field => this.getTicketValue(this.state.selected_ticket, raw_field)).join(' ')
        }
        console.log("Class Query Object : ", object)
        return object
      })
    }

    let additional_ic_query_object = params.reco_sources !== null ? this.getAdditionalICQueryObject(params, "Classify") : []

    if (params.show_class) {
      class_query_object.push(default_query_object)
    }
    //class_query_object = [...class_query_object, ...additional_ic_query_object]
    if (params.reco_sources !== null) {
      let reco_sources = params.reco_sources
      additional_ic_query_object.forEach(object => {
        let source = reco_sources.find(src => src.ic_name === object.ic_name)
        if (source.show_class) {
          class_query_object.push(object)
        }
      })
    }

    return class_query_object
  }

  getSearchString = () => {
    let selected_ticket_object = this.state.selected_ticket_object
    console.log("Selected Ticket Object For SearchString : ", selected_ticket_object)
    let search_string = selected_ticket_object.fields.map(field => field.value).join(" ")
    //let search_string = this.state.query_object[0].search_options.map(op => op.search_query).join(" ")
    return search_string
  };

  getICTabList = () => {
    let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
    let screens = routes.find(section => section.id === 'cases')
    let screen = screens.screens.find(route => route.route === this.props.location.pathname)
    let params = screen.default_params
    let reco_sources = []
    reco_sources.push(params.icName)
    params.reco_sources.map(source => {
      reco_sources.push(source.ic_name)
    })

    return reco_sources
  }

  getAttachmentOptions = () => {
    console.log("Selected ticket display config : ", this.state.selected_ticket_display_config)
    let attachment_option = []
    if (this.state.selected_ticket_display_config) {
      this.state.selected_ticket_display_config.write.map(field => {
        let accepts_attachment = false
        
        let attachment_param = field.component_params.find(param => param.name === 'accept_attachment')
        if (attachment_param) {
          accepts_attachment = attachment_param.value.boolean
        }
        
        if (accepts_attachment) {
          let option = {
            type : 'field',
            field : field.name,
            helper : "Attach to Field",
            accepts_attachment : true
          }
          attachment_option.push(option)
        }
      })
  
      let attachment_global_param = this.state.selected_ticket_display_config.params.find(param => param.name === "Global Attachments")
  
      if (attachment_global_param) {
        let global_attachment = attachment_global_param.value.boolean
        if (global_attachment) {
          let global_attachment_option = {
            type : "record",
            field : "Record Level",
            helper : "Attach to Record",
            accepts_attachment : true
          }
  
          attachment_option.unshift(global_attachment_option)
        }
      }
    }
    
    return attachment_option
  }

  reAttachAttachment = (field_option, attachment_object) => {
    console.log("Re-Attaching : Attachment : ", attachment_object)
    console.log("Re-Attaching : To Field : ", field_option)
    console.log("Re-Attaching : To Record : ", this.state.selected_ticket_object)

    let re_attach_destination_type = field_option.type

    if (re_attach_destination_type === 'record') {
      let selected_ticket_object = this.state.selected_ticket_object
      selected_ticket_object.record_level_attachments.push((attachment_object))

      this.setState({...this.state, selected_ticket_object : selected_ticket_object})
    } else if (re_attach_destination_type === 'field') {

      let ticket_config = this.state.selected_ticket_display_config
      let ticket_write_config = ticket_config.write
      let edit_field = ticket_write_config.find(fields => fields.name === field_option.field)

      if (edit_field.attachments) {
        edit_field.attachments.push(attachment_object)
      } else {
        edit_field.attachments = [attachment_object]
      }

      console.log("Re-Attaching : Adding Field Attachment", ticket_config)
      this.setState({...this.state, selected_ticket_display_config : ticket_config})
    }
  }

  renderResults = () => {
    var toPX = require('to-px')
    console.log(this.state.results_received)
    if (this.state.result_received && this.state.query_result !== null) {
      // console.log("Screen Height :", this.screenHeight.current.clientHeight)
        // let result_container_height = this.screenHeight.current.clientHeight - this.searchBar.current.clientHeight
        //let result_container_height = screen_height - this.searchBar.current.clientHeight + 50

        // return this.renderSainapseResults()
        return (
            <div>
                {this.renderResultsTabs()}
                {this.renderResultsTabContainers()}
            </div>
        )

    }
  }

  renderResultsTabs = () => {
    // var toPX = require("to-px");
    // let cur_height = toPX('100vh')
    // let container_height = cur_height - 60
    return (
        <Paper square variant = 'outlined' style = {{width : '100%', padding : 0, margin: 0, borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
            <Tabs
                value={this.state.results_tab}
                indicatorColor="primary"
                textColor="primary"
                onChange={(event, newValue) => this.setState({...this.state, results_tab : newValue})}
                aria-label="disabled tabs example"
            >
                <Tab label="Sainapse Results"/>
                {this.state.external_sources.map(src => {
                    return (
                        <Tab label = {src.link_name}/>
                    )
                })}
            </Tabs>
        </Paper>
    )
  }

  getLinkConfig = (results_tab) => {
    if (results_tab !== 0) {
        let external_source = this.state.external_sources[results_tab - 1]
        let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
        let links_section = routes.find(section => section.id === 'links')
        let link_config = links_section.screens.find(screen => screen.id === external_source.link_id)
        if (link_config) {
            return link_config
        } else {
            return null
        }
    }
  }

  getLinkQueryParams = (results_tab) => {
      let external_source = this.state.external_sources[results_tab - 1]
      let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
      let links_section = routes.find(section => section.id === 'links')
      let link_config = links_section.screens.find(screen => screen.id === external_source.link_id)

      let link_query_params = link_config.default_params.query_params
      let query_params = link_query_params.map(qp => {
          let query_map = external_source.query_map.find(qm => qm.key_name === qp.key)
          let value_list = query_map.value_map.map(field => {
             return this.state.selected_rowData[field]
          })
          return {
              key : qp.key,
              default_value : value_list.join(" ")
          }
      })

      return query_params
  }

  renderResultsTabContainers = () => {
    var toPX = require("to-px");
    let cur_height = toPX('100vh')
    let container_height = cur_height - 120
    if (this.state.results_tab === 0) {
        return this.renderRecommendations()
    } else {
        return (
            <LinkedScreen
                key = {this.state.results_tab}
                embedded = {true}
                config = {this.getLinkConfig(this.state.results_tab) !== null ? this.getLinkConfig(this.state.results_tab) : {}}
                width = {this.state.show_ticket ? toPX("64vw") : toPX('100vw')}
                height = {container_height}
                query_params = {this.getLinkQueryParams(this.state.results_tab)}
            />
        )
    }
  }

  renderRecommendations = () => {
    var toPX = require("to-px");
    if (this.state.result_received && this.state.query_result !== null) {
      console.log("Window Size Width : ", this.state.window_width)
      console.log("Window Size Height : ", this.state.window_height)
      return (
        <Fragment>
          <Result
            height={this.state.window_height}
            width={this.state.window_width}
            results={this.state.query_result}
            ic_list = {this.getICTabList()}
            reco_label="Recommendations"
            class_results={this.state.class_result}
            class_label="Classification Results"
            drl_url={this.state.drl_url}
            searching={this.state.searching}
            search_string={() => ""}
            key_terms={[]}
            copy={(text) => this.copyText(text)}
            re_attach = {this.state.copy_to_parent ? false : true}
            attach_options = {this.state.copy_to_parent ? [] : this.getAttachmentOptions()}
            re_attach_attachment = {(field_option, attachment_object) => this.reAttachAttachment(field_option, attachment_object)}
            cta_config = {this.state.cta_config}
            execute_cta = {(cta_config, record) => this.executeCTA(cta_config, record)}
          />
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={this.state.snackbar_open}
            onClose={this.handleClose}
            message="Text Copied"
            autoHideDuration={1000}
          />
        </Fragment>
      );
    }

    if (this.state.searching === true) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="primary" />
          <Typography
            style={{ display: "block", marginTop: "10px" }}
            variant="caption"
            color="primary"
          >
            Getting Recommendations...
          </Typography>
        </div>
      );
    }

    if (this.state.query_error) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            style={{ display: "block", marginTop: "10px" }}
            variant="caption"
            color="secondary"
          >
            Error in fetching recommendations.
          </Typography>
        </div>
      );
    }

    if (this.state.ic_name === null || this.state.iu_name === null) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            style={{ display: "block", marginTop: "10px" }}
            variant="caption"
            color="primary"
          >
            Select Incident Source.
          </Typography>
        </div>
      );
    } else {
      if (this.state.selected_ticket === null && this.state.tickets !== null) {
        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              style={{ display: "block", marginTop: "10px" }}
              variant="caption"
              color="primary"
            >
              Select A ticket to get recommendations.
            </Typography>
          </div>
        );
      }
    }
  };

  executeCTA = (cta_config, record) => {
    console.log("CTA Executed for record : ", record)
    console.log("CTA Executed for config : ", cta_config)
    console.log("CTA Executed for Open Record : ", this.state.selected_ticket_object)
  
    let field_maps = cta_config.fields
    let key_values = []
    field_maps.forEach(fmap => {
        let entry = []
        entry[0] = fmap.field_name

        let value_source = fmap.source.split('.')[0]
        let value_type = fmap.source.split('.')[1]

        if (value_source === 'native') {
            if (value_type === 'raw_field') {
                entry[1] = record.raw_fields.fields.find(field => field.name === fmap.mapped_to).value
            } else if (value_type === 'world_view') {
                entry[1] = record.wv_field_list.find(field => field.name === fmap.mapped_to).value.text
            }
        } else if (value_source === 'external') {
          if (value_type === 'raw_field') {
            entry[1] = this.state.selected_ticket_object.fields.find(field => field.name === fmap.mapped_to).value
          }
        } else if (value_source === 'custom') {
          if (value_type === 'static') {
            entry[1] = fmap.mapped_to
          }
        }

        key_values.push(entry)
    })

    // let fields = Object.fromEntries(key_values)

    if (cta_config.post_to_parent) {
        let payload = Object.fromEntries(key_values)
        window.parent.postMessage({ message : "Sainapse: CTA", value : JSON.stringify(payload)}, "*")
    } else {
        let query_params = key_values.map(key_value => key_value[0] + "=" + encodeURIComponent(key_value[1]))
        let query_string = query_params.join('&')
        let trigger_url = cta_config.trigger_url + "?" + query_string
        if (cta_config.open_in_new_window) {
          console.log("new window", cta_config.open_in_new_tab)
          window.open(trigger_url, "cta-window", "width=1000,height=800")
        }
        else {
            window.open(trigger_url)
        }
    }
}

  copyText = (text) => {
    if (this.state.copy_to_parent) {
      window.parent.postMessage({ message : "Sainapse: Copy Content", value : text}, "*")
      navigator.clipboard.writeText(text)
    } else {
      let copyable_fields = []    
      this.state.selected_ticket_display_config.write.map(field => {
        let auto_paste_index = field.component_params.findIndex(param => param.name === 'auto_paste')
        if (auto_paste_index !== -1) {
          let auto_paste_enabled = field.component_params[auto_paste_index].value.boolean
          if (auto_paste_enabled) {
            copyable_fields.push(field.name)
          }
        }
      })
      let new_state = clone(this.state)
      new_state.selected_ticket_display_config.write.map(field => {
        console.log("Copy- Evaluating Field : ", field.name)
        if (copyable_fields.includes(field.name)) {
          console.log("Copy- Can accept Copy : ", field.name)
          if (field.value.text === null || field.value.text === undefined) {
            field.value.text = text
          } else {
            field.value.text = field.value.text + "\n \n" + text
          }
        }
      })
      console.log("Copy- Copied State: ", new_state.selected_ticket_display_config)
      navigator.clipboard.writeText(text)
      this.setState({...new_state, snackbar_open: true})
    }
  };

  handleClose = () => {
    this.setState({ ...this.state, snackbar_open: false });
  };

  closeError = () => {
    this.setState({ ...this.state, error: false, error_message: null });
  };

  renderError = () => {
    if (this.state.error === true) {
      return (
        <ThemeProvider theme={blue_theme}>
          <ErrorMessageAlert
            open={this.state.error}
            handleClose={this.closeError}
            errorInfo={this.state.error_message}
          />
        </ThemeProvider>
      );
    }
  }

  selectTicket = (rowData) => {
    console.log("Selecting Ticket : ", rowData)
    let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
    let screens = routes.find(section => section.id === 'cases')
    let screen = screens.screens.find(route => route.route === this.props.location.pathname)
    let params = screen.default_params
    let columns = params.columns
    let id_field = columns.find(column => column.type === 'id').name
    console.log("Selected ID Field : ", id_field)
    let id = rowData[id_field]
    
    this.setState({...this.state, selected_ticket : id, getting_selected_ticket : true, selected_ticket_error : null, selected_rowData : rowData }, () => {
      let sorted_column_index = this.state.columns.findIndex(column => column.sort !== null)
      let data = this.generateAPIData(this.state.ic_name.name, this.state.iu_name.name, this.state.columns[sorted_column_index].name, this.state.columns[sorted_column_index].sort)
      Actions('http_request', {
        url:
            "/sainapse/information_channel/" +
            this.state.ic_name +
            "/information_unit/" +
            this.state.iu_name +
            "/raw_data",
          method: "post",
        data : data
      }).then(res => {
        let selected_ticket_object = res.data.result[0]
        Actions('http_request', {
          url : "/sainapse/information_channel/" + this.state.ic_name + "/information_unit/" + this.state.iu_name + "/display_config",
          method : "get",
          data : {}
        }).then(res => {
          console.log("Display Config : ", res.data.result)
          this.setState({
            ...this.state, 
            selected_ticket_object : selected_ticket_object, 
            selected_ticket_display_config : this.generateConfigFromRecord(selected_ticket_object, res.data.result), 
            show_table : false,
            getting_selected_ticket : false
          }, () => {
            this.generateMultiFieldQuery(params)
          })
        }).catch(err => {
          this.setState({...this.state, selected_ticket : null, getting_selected_ticket : false, selected_ticket_error : err })
        })
      })
    })
  }

  generateMultiFieldQuery = (params) => {
    Actions("http_requests", [
      {
        url: "/sainapse/information_channel/" + this.state.ic_name + "/world_view",
        method: "get",
        data: {},
      }, 
      {
        url : "/sainapse/information_channel/" + this.state.ic_name + "/information_unit/" + this.state.iu_name + "/world_view",
        method : "get",
        data : {}
      }
    ]).then(res => {
      let default_ic_wv = res[0].data.result
      let default_iu_wv = res[1].data.result

      let source_config_list = []
      let default_source_config = [default_ic_wv, default_iu_wv]
      source_config_list.push(default_source_config)

      let reco_configs = params.reco_sources.map(reco_source => {
        let reco_payload = {
          ic_name : reco_source.ic_name,
          ic_wv : null,
          ic_payload : {
            url : "/sainapse/information_channel/" + reco_source.ic_name + "/world_view",
            method : "get",
            data : {}
          },
          wv_config : {
            world_view_fields: reco_source.search_options
          },
          show_class : reco_source.show_class
        }
        return reco_payload
      })

      let reco_payload = reco_configs.map(reco_config => reco_config.ic_payload)
      Actions('http_requests', reco_payload).then(res => {
        reco_configs.map((reco_config, i) => {
          reco_config.ic_wv = res[i].data.result
        })

        let default_reco_config = {
          ic_name : this.state.ic_name,
          ic_wv : default_ic_wv,
          ic_payload : null,
          wv_config : default_iu_wv,
          show_class : params.show_class
        }
        reco_configs.unshift(default_reco_config)

        console.log("Queue Recommendation Config : ", reco_configs)
        console.log("Queue Recommendation Config Record : ", this.state.selected_ticket_object)

        let search_options = reco_configs.map(reco_config => this.generateSearchOptions(this.state.selected_ticket_object, reco_config))
        console.log("Queue Recommendation Config Search Options : ", search_options)
        
        let recommendation_query = []
        let classification_query = []

        reco_configs.map((reco_config, i) => {
          reco_config.ic_wv.configs.map((config, j) => {
            let filters = params.filters.find(filter => filter.ic_name === reco_config.ic_name)

            if (config.operation === 'Recommend') {
              let search_payload = {
                ic_name : reco_config.ic_name,
                filters : filters ? [filters] : [],
                search_options : []
              }
              console.log("Search Options Array : ", search_options)
              let search_option_index = search_options[i].findIndex(option => option.operation === 'Recommend')
              console.log("Recommendation Search Option Index : ", search_option_index)
              console.log("Recommendation Pre Search Options : ", search_options[i][search_option_index].search_option)
              if (search_option_index !== -1) {
                search_payload.search_options = search_options[i][search_option_index].search_option
              }
              console.log("Recommendation Search Payload : ", search_payload)
              recommendation_query.push(search_payload)
              console.log("Recommendation Query Payload : ", recommendation_query)
            }

            if (config.operation === 'Classify') {
              let search_payload = {
                ic_name : reco_config.ic_name,
                filters : filters ? [filters] : [],
                search_options : []
              }
              let search_option_index = search_options[i].findIndex(option => option.operation === 'Classify')
              if (search_option_index !== -1) {
                search_payload.search_options = search_options[i][search_option_index].search_option
              }
              classification_query.push(search_payload)
            }
          })
        })

        console.log("Payload Recommendation : ", recommendation_query)
        console.log("Payload Classification : ", classification_query)

        this.setState(
          {
            ...this.state,
            wv_error: false,
            iu_wv_fields_error: false,
            searching: true,
            query_object: recommendation_query,
          },
          () => {
            Actions('http_request', {
                url : "/sainapse/recommendation/multifield",
                method: "post",
                data : recommendation_query
            }).then(res => {
              this.setState(
                {
                  ...this.state,
                  query_result: res.data.result,
                  searching: false,
                  result_received : true,
                  query_error : false,
                }
              );
            }).catch(err => {
              this.setState(
                {
                  ...this.state,
                  query_result: [],
                  searching: false,
                  result_received : true,
                  query_error : true,
                }
              );
            })

            Action('http_request', {
              url : "/sainapse/classification/multifield",
              method: "post",
              data : classification_query
            }).then(res => {
              this.setState(
                {
                  ...this.state,
                  class_result : res.data.result,
                  class_result_received : true
                }
              );
            }).catch(err => {
              this.setState(
                {
                  ...this.state,
                  class_result : [],
                  class_result_received : false
                }
              );
            })

            // Actions('http_requests', [
            //   {
            //     url : "/sainapse/recommendation/multifield",
            //     method: "post",
            //     data : recommendation_query
            //   },
            //   {
            //     url : "/sainapse/classification/multifield",
            //     method: "post",
            //     data : classification_query
            //   }
            // ]).then(res => {
            //   console.log("Multifield Search Results : ", res)
            //   this.setState(
            //     {
            //       ...this.state,
            //       query_result: res[0].data.result,
            //       searching: false,
            //       result_received : true,
            //       query_error : false,
            //       class_result : res[1].data.result,
            //       class_result_received : true
            //     }
            //   );
            // }).catch(err => {
    
            // })
          }
        )
      }).catch(err => {

      })
    }).catch(err => {

    })
  }

  generateSearchOptions = (record, reco_config) => {
    console.log("Reco Config in Queue: ", reco_config)
    let operations = reco_config.ic_wv.configs.map(config => config.operation)
    if (reco_config.show_class === false) {
      if (operations.includes("Classify")) {
        operations = operations.filter(op => op !== "Classify")
      }
    }
    console.log("Generatin Search Query for operations : ", operations)
    let search_options = operations.map(operation => this.generateSearchOption(record, reco_config, operation))
    console.log("Search Options : ", search_options)
    return search_options
  }

  generateSearchOption = (record, reco_config, operation) => {
    let predictors = reco_config.ic_wv.configs.find(config => config.operation === operation).fields.filter(field => field.role === "Predictor").map(field => field.name)
    console.log("Predictors : ", predictors)
    let search_option = predictors.map(predictor => {
      console.log('Getting map for Predictor : ', predictor)
      let iu_wv_config = reco_config.wv_config.world_view_fields.find(field => field.name === predictor)
      console.log('IU Config : ', iu_wv_config)
      let base = this.getBaseValue(iu_wv_config, record)
      console.log('Base Value : ', base)
      let global_attachment_value = this.state.get_global_attachments ? this.getAttachmentValue(iu_wv_config, record) : ""
      console.log("Global Attachment Value : ", global_attachment_value)
      let field_search_query = base + " " + global_attachment_value

      return {
        field_name : predictor,
        search_query : field_search_query
      }
    })
    
    search_option = {
      operation : operation,
      search_option : search_option
    }
    
    return search_option
  }

  getBaseValue = (field_config, record) => {
    console.log('Getting Base Value : ', record)
    let base_value = field_config.base.map(field => {
      let raw_field = record.fields.find(fld => fld.name === field.name)
      let field_value_split = raw_field.value.split(/(\[SAINAPSE_ATTACHMENT:[ A-Za-z0-9_@./#&+-]*\])/)
      console.log('Field Value Split : ', field_value_split)
      let field_value = field_value_split.map(val => {
        if (val[0] === '[' && val[val.length -1] === ']') {
          let hash = val.substring(21, val.length -1)
          let attachment_object_index = raw_field.embedded_attachment_meta_data.findIndex(attachment => attachment.inlineHash === hash)
          if (attachment_object_index !== -1) {
            let attachment_object = raw_field.embedded_attachment_meta_data[attachment_object_index]
            return attachment_object.file_extraction_data.value
          } 
        } else {
          return val
        }
      })
      field_value = field_value.join(" ")
      let field_attachment_value = field.include_field_level_attachment ? record.fields.find(fld => fld.name === field.name).attachment_meta_data_list.map(attachment => attachment.file_extraction_data.value).join(" ") : ""
      let value = field_value + " " + field_attachment_value
      return value
    })

    return base_value.join(" ")
  }

  getAttachmentValue = (field_config, record) => {
    console.log('Getting Attachment Value : ', record)
    let attachment_value = field_config.record_level_attachment_filters.attachment_enabled ? record.record_level_attachments.map(attachment => attachment.file_extraction_data.value).join(" ") : ""
    return attachment_value
  }

  generateConfigFromRecord = (record, config) => {
    config.write.map(field => {
      let binding_key = field.component_params.find(param => param.name === 'binding_key').value.text
      let field_index = record.fields.findIndex(fld => fld.name === binding_key)
      let field_type = valueType[field.component]
      console.log(field.component)
      console.log(" : ", field_type.type)
      if (field_type.type === 'list') {
        field.value[field_type.type] = record.fields[field_index].value === '' ? [] : record.fields[field_index].value.split(";")
      }
      else if (field_type.type === 'boolean') {
        field.value[field_type.type] = record.fields[field_index].value === 'false' ? false : true
      } 
      else if (field_type.type === 'number') {
        field.value[field_type.type] = Number(record.fields[field_index].value)
        if (Number.isNaN(field.value[field_type.type])) 
          field.value[field_type.type] = record.fields[field_index].value
      }
      else {
        field.value[field_type.type] = record.fields[field_index].value
      } 
      console.log("value : ", field.value[field_type])
      field.attachments = record.fields[field_index].attachment_meta_data_list
      field.embedded_attachments = record.fields[field_index].embedded_attachment_meta_data
    })

    return config
  }

  generateRecordFromConfig = (record, config) => {
    console.log("Record Field Record Pre Submit: ", record)
    record.fields.map(record_field => {
      let display_field_index = this.state.selected_ticket_display_config.write.findIndex(field => field.component_params.find(param => param.name === 'binding_key').value.text === record_field.name)
      if (display_field_index !== -1) {
        let field = this.state.selected_ticket_display_config.write[display_field_index]
        let field_type = valueType[field.component]
        let field_value = this.state.selected_ticket_display_config.write[display_field_index].value[field_type.type]
        if (field_type.type === 'list') {
          field_value = field_value.join(';')
        } 
        record_field.value = field_value !== null ? field_value.toString() : ""
        if (this.state.selected_ticket_display_config.write[display_field_index].attachments) {
          if (this.state.selected_ticket_display_config.write[display_field_index].attachments.length > 0) {
            record_field.attachment_meta_data_list = this.state.selected_ticket_display_config.write[display_field_index].attachments
          }
        }
      } 
    })

    // let final_record
    // this.state.selected_ticket_display_config.write.map(field => {
    //   let binding_key = field.component_params.find(param => param.name === 'binding_key').value.text
    //   final_record[binding_key] = field.value.text
    // })
    console.log("Record Field Record : ", record)
    return record
  }

  submitRecordToSource = () => {
    let ticket = this.generateRecordFromConfig(this.state.selected_ticket_object, this.state.selected_ticket_display_config.write)
    this.setState({...this.state, updating_record: true, update_record_error : false}, () => {
      Actions("http_request", {
        url:
          "/sainapse/information_channel/" +
          this.state.ic_name +
          "/information_unit/" +
          this.state.iu_name +
          "/update_data",
        method: "post",
        data: {
          data: [ticket],
        },
      }).then(res => {
        this.setState({...this.state, updating_record: false, update_record_error : false}, () => {
          this.closeTicketEditor()
        })
      }).catch(err => {
        this.setState({...this.state, updating_record: false, update_record_error : true})
      })
    })
  }

  getIDField = () => {
    let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
    let screens = routes.find(section => section.id === 'cases')
    let screen = screens.screens.find(route => route.route === this.props.location.pathname)
    let params = screen.default_params
    let columns = params.columns
    let id_field = columns.find(column => column.type === 'id').name

    return id_field
  }

  renderQueueTable = () => {
      if (this.state.tickets !== null) {
        let columns
        if (this.state.columns !== null && this.state.columns !== []) {
          let visible_columns = this.state.columns.filter(column => column.visibility === 'show')
          columns = visible_columns.map(column => {
              let col = {
                title : column.col_name? column.col_name: column.name,
                field : column.name
              }
              if (column.type === 'date-time') {
                col.type = "datetime"
              }            
    
              // if (column.sort !== null) {
              //   col.defaultSort = column.sort
              // }
    
              return col
          })
        } else {
          columns = Object.keys(this.state.tickets[0]).map(column => {
            let col = {
              title : column,
              field : column
            }

            return col 
          })
        }

        columns.unshift({
          title : 'Action',
          field : "",
          render : (rowData) => {
            return (
              <Button
                variant = 'outlined'
                color = 'primary'
                size = 'small'
                onClick = {() => this.selectTicket(rowData)}
                startIcon = {
                  rowData[this.getIDField()] === this.state.selected_ticket && this.state.getting_selected_ticket && 
                  <CircularProgress color = "primary" size = {20}/>
                }
              >
                Resolve
              </Button>
            )
          }
        })
        console.log("Queue table Data : ",this.state.tickets)
        return (
          <div>
            <Paper square elevation = {2} style = {{width : '100%', height : '75px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px'}}>
              <div style = {{flexGrow : 1}}>
                {this.renderScreenName()}
              </div>
              <div style = {{width : '20%', marginRight : '10px', borderRadius : '5px', border : '1px solid rgba(0,0,0,0.12)', padding : '5px'}}>
                {this.renderICSelect()}
              </div>
              <div style = {{width : '20%', marginRight : '10px', borderRadius : '5px', border : '1px solid rgba(0,0,0,0.12)', padding : '5px'}}>
                {this.renderIUSelect()}
              </div>
              <div>
                {this.renderGetTickets()}
              </div>
            </Paper>
            <MaterialTable
              // style={{ width: "98%", margin : '10px'}}
              icons={table_icons}
              title = ""
              data={this.state.tickets}
              columns = {columns}
              onOrderChange = {(orderedColumnId, orderDirection) => console.log("Column : " + orderedColumnId + " :: Direction : " + orderDirection )}
              localization = {{
                pagination : {
                  labelDisplayedRows : "30 - 40 of 500"
                }
              }}
              options={{
                search: false,
                cellStyle: {
                  wordWrap : 'break-word',
                  minHeight: "40px",
                  maxHeight  : '120px',
                  overflowY : 'auto',
                  paddingLeft : '5px',
                  paddingTop: '5px',
                  paddingBottom: '5px',
                  fontSize : '13px'
                },
                toolbar : false,
                maxBodyHeight: "80vh",
                paging: false,
                pageSize : 10,
                pageSizeOptions : [10, 15, 20],
                paginationType : 'stepped',
                headerStyle: {
                  height : '50px',
                  padding: 0,
                  paddingLeft : '5px',
                  backgroundColor: "#F0F0F0",
                  zIndex : 10
                },
              }}
            />
            <div style = {{ display : 'flex', flexDirection : 'row', marginTop : '10px', justifyContent : 'center'}}> 
              <Pagination style = {{paddingRight : '10px'}} count = {this.state.pages} page={this.state.cur_page} showFirstButton showLastButton onChange = {(event, value) => this.changePage(value)}/>
            </div>
          </div>
        )
      }
  }

  changePage = (value) => {
    console.log("Page Changed : ", value)
    let limit = this.state.limit
    let offset = ((value - 1) * limit)
    this.setState({
      ...this.state,
      cur_page : value,
      last_offset : offset
    }, () => {
      let sorted_column_index = this.state.columns.findIndex(column => column.sort !== null)
      this.getTickets(this.state.ic_name, this.state.iu_name, this.state.columns[sorted_column_index].name, this.state.columns[sorted_column_index].sort)
    })
  }

  closeTicketEditor = () => {
    this.setState({
      ...this.state, 
      selected_ticket : null,
      selected_ticket_display_config : null,
      wv_error: false,
      iu_wv_fields_error: false,
      query_object: null,
      class_query_object : null,
      searching: false,
      query_result: null,
      query_error : false,
      show_table : true
    }, () => {
      let sorted_column_index = this.state.columns.findIndex(column => column.sort !== null)
      this.getTickets(this.state.ic_name, this.state.iu_name, this.state.columns[sorted_column_index].name, this.state.columns[sorted_column_index].sort)
    })
  }

  updateTicket = (form) => {
    let new_state = clone(this.state)
      new_state.selected_ticket_display_config.write = form
      this.setState({...new_state}, () => console.log("Record Field Record Updated: ", this.state.selected_ticket_display_config))
  }

  copyToClipboard = () => {
    let copy_content = ""
    this.state.selected_ticket_display_config.write.map(field => {
      let auto_paste_index = field.component_params.findIndex(param => param.name === 'copy_content')
      if (auto_paste_index !== -1) {
        let auto_paste_enabled = field.component_params[auto_paste_index].value.boolean
        if (auto_paste_enabled) {
          copy_content = copy_content + field.value.text
        }
      }
    })
    navigator.clipboard.writeText(copy_content)
  }

  addAdditionalAttachments = (attachment) => {
    let selected_ticket_object = this.state.selected_ticket_object
    selected_ticket_object.record_level_attachments.push((attachment))
    this.setState({...this.state, selected_ticket_object : selected_ticket_object})
  }


  renderTicketEditor = () => {
    if (this.state.selected_ticket !== null && this.state.tickets !== null) {
      return (
        <div>
          {/* <Paper square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', backgroundColor : "#2296f3", color : '#FFFFFF'}}>
            <Typography style = {{flexGrow : 1}} variant = 'h6'>{this.state.selected_ticket}</Typography>
            <IconButton size = 'small' onClick = {this.closeTicketEditor}>
              <Clear style = {{color : "#FFFFFF"}} fontSize = 'small'/>
            </IconButton>
          </Paper> */}
          <div style = {{
              width : '100%', 
              height : this.props.params.showAppbar === undefined ? 'calc(100vh - 50px)' : JSON.parse(this.props.params.showAppbar) === true ? 'calc(100vh - 50px)' : '100vh', 
              display : 'flex', 
              flexDirection : 'row'
            }}>
            {this.state.show_ticket && <div style = {{width : '35%', borderRight : '1px solid rgba(0,0,0,0.12)', maxHeight : '100%', overflow : 'auto', display : 'flex', flexDirection : 'column'}}>
              {this.state.show_back && <div>
                <Button 
                  style = {{marginLeft : '10px', marginTop : '10px'}} 
                  size = 'small' 
                  onClick = {this.closeTicketEditor} 
                  color = 'secondary'
                  variant = 'contained'
                  startIcon = {<ArrowBack/>}
                >
                  Back to Queue
                </Button>
              </div>}
              <div style = {{padding : '10px'}}>
                <AttachmentContainer
                  accepts_attachments = {true}
                  attachments = {this.state.selected_ticket_object.record_level_attachments}
                  drl_url = {this.state.drl_url}
                  ic_name = {this.state.ic_name}
                  additional_attachments = {this.state.additional_attachments}
                  add_attachments = {(attachment) => this.addAdditionalAttachments(attachment)}
                  on_open = {true}
                />
              </div>
              <div style = {{flexGrow : 1}}>
                <Ticket 
                  drl_url = {this.state.drl_url}
                  ic_name = {this.state.ic_name}
                  config = {this.state.selected_ticket_display_config} 
                  updateForm = {(form) => this.updateTicket(form)} 
                  copyToClipboard = {() => this.copyToClipboard()} 
                  submit = {() => this.submitRecordToSource()}
                  updating_record = {this.state.updating_record}
                  update_record_error = {this.state.update_record_error}
                />
              </div>
            </div>}
            <div style = {{flexGrow :1, height : '100%', overflow : 'auto'}}>
              {this.renderResults()}
            </div>
          </div>
        </div>
      )
    }
  }

  renderContent = () => {
    if (this.state.init_error === true) {
      return (
        <div style = {{width :'100%', height : 'calc(100vh - 125px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
            <Paper style = {{width : '50%', padding : '15px'}}>
                <Typography variant='h6' display = 'block'>Configuration Error</Typography>
                <Divider style = {{marginTop : '5px', marginBottom : '5px'}} />
                <Typography variant = 'body2' display = 'block'>Queue Configuration should contain the following:</Typography>
                <Typography variant = 'body2' display = 'block'>1. Date Field with sorting options</Typography>
                <Typography variant = 'body2' display = 'block'>2. ID Field</Typography>
            </Paper>
          </div>
      )
    } else {
      if (this.state.getting_tickets === true) {
        return (
          <div style = {{width :'100%', height : 'calc(100vh - 125px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
            <Paper style = {{width : '150px', height : '75px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                <CircularProgress variant = 'indeterminate' size = {30} color = 'primary'/>
            </Paper>
          </div>
        )
      } else {
        if (this.state.show_table) {
          return this.renderQueueTable()
        } else {
          if (this.state.tickets === null) {
            return (
              <div style = {{width :'100%', height : 'calc(100vh - 125px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                <Paper style = {{width : '150px', height : '75px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress variant = 'indeterminate' size = {30} color = 'primary'/>
                </Paper>
              </div>
            )
          } else {
            if (this.state.selected_ticket_object) {
              return this.renderTicketEditor()
            }
          }
        }
      }
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <ThemeProvider theme={blue_theme}>
        <div
          style={{
            width: "100vw",
            height: "calc(100vh - 48px)"
          }}
        >
          {/* {this.renderQueueTable()}
          {this.renderTicketEditor()} */}
          {this.renderContent()}
        </div>
        {this.renderError()}
        <ErrorMessageAlert
          errorInfo={this.state.selected_ticket_error}
          open = {this.state.selected_ticket_error !== null ? true : false}
          handleClose={() => this.setState({...this.state, selected_ticket_error : null})}
        />
      </ThemeProvider>
    );
  }
}

export default withRouter(withStyles(styles)(Queue));
